module.exports = __webpack_public_path__ + "static/media/cellfinate_fondo_bolitas.04acb1d9.png";